import {
  CALL_API,
} from 'redux-api-middleware'

import {
  VERIFY_REQUEST,
  VERIFY_SUCCESS,
  VERIFY_FAILURE,
  VARIFY_IMAGE_REQUEST,
  VARIFY_IMAGE_SUCCESS,
  VARIFY_IMAGE_FAILURE,
  CHECK_ACTIVE_REQUEST,
  CHECK_ACTIVE_SUCCESS,
  CHECK_ACTIVE_FAILURE,
} from './types'
import {
  VERIFY_EP,
} from '../constant'
import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const checkActive = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [
      CHECK_ACTIVE_REQUEST,
      CHECK_ACTIVE_SUCCESS,
      CHECK_ACTIVE_FAILURE,
    ],
  },
})

export const submitVerify = (endpoint, verifyForm) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(verifyForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [
          VERIFY_REQUEST,
          {
            type: VERIFY_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              window.location.replace('/instructor/review')
              return response
            },
          },
          VERIFY_FAILURE,
        ],
      },
    })
  }
}

export const uploadVerifyImage = (endpoint, img) => {
  const formData = new FormData(img)
  formData.append('imagePassportId', img)
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: formData,
        headers,
        types: [VARIFY_IMAGE_REQUEST,
          {
            type: VARIFY_IMAGE_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              return response
            },
          },
          VARIFY_IMAGE_FAILURE,
        ],
      },
    })
  }
}
export const submitVerifyForInstructer = (endpoint, verifyForm, tokenFromRegister, redirect) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(verifyForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': tokenFromRegister,
          'server-name': 'deknerd',
        },
        types: [
          VERIFY_REQUEST,
          {
            type: VERIFY_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              redirect !== null ? window.location.replace(redirect) : window.location.replace('/instructor/review')
              return response
            },
          },
          VERIFY_FAILURE,
        ],
      },
    })
  }
}
export const uploadVerifyImageForInstructor = (endpoint, img, tokenFromRegister, registerFormInstructor, redirect) => {
  const formData = new FormData(img)
  formData.append('imagePassportId', img)
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: formData,
        headers: {
          'x-session-token': tokenFromRegister,
          'server-name': 'deknerd',
        },
        types: [VARIFY_IMAGE_REQUEST,
          {
            type: VARIFY_IMAGE_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              // const { fileName } = response
              await dispatch(submitVerifyForInstructer(VERIFY_EP, { ...registerFormInstructor, imagePassportId: response }, tokenFromRegister, redirect))
              // await redirect !== null ? window.location.replace(redirect) : window.location.replace('/instructor/review')
              return response
            },
          },
          VARIFY_IMAGE_FAILURE,
        ],
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/verify.js